import {useState, useCallback} from 'react'
import axios from 'axios'

export default () => {
    const [options, setOptions] = useState([])
    const [addressLoading, setAddressLoading] = useState(false)

    const bounds = {
        southwest: {lat: 43.499, lng: -97.239},
        northeast: {lat: 49.384, lng: -89.491},
    }

    const search = useCallback(async query => {
        if (!query || query.length < 3) {
            setOptions([])
            return
        }
        setAddressLoading(true)
        try {
            const {
                data: {results},
            } = await axios.get('https://api.geoapify.com/v1/geocode/autocomplete', {
                params: {
                    apiKey: process.env.REACT_APP_GEOAPIFY_KEY,
                    format: 'json',
                    limit: 5,
                    filter: `rect:${bounds.southwest.lng},${bounds.southwest.lat},${bounds.northeast.lng},${bounds.northeast.lat}`,
                    text: query,
                },
            })
            setOptions(results || [])
        } catch (err) {
            console.error('Geoapify error:', err)
        } finally {
            setAddressLoading(false)
        }
    }, [])

    return {options, addressLoading, search}
}
